import { DefaultParsers } from './defaultParsers';
import defaultConfig from './config';
import { mergeDeep, embedMarkups } from './utilities';
export class edjsParser {
    constructor(config = {}, customs = {}, embeds = {}) {
        this.config = mergeDeep(defaultConfig, config);
        this.config.embedMarkups = Object.assign(embedMarkups, embeds);
        this.parsers = Object.assign(DefaultParsers, customs);
    }
    parse(EditorJsObject) {
        const html = EditorJsObject.blocks.map((block) => {
            return this.parseBlock(block);
        });
        return html.join('');
    }
    parseBlock(block) {
        if (!this.parsers[block.type]) {
            return '';
        }
        try {
            return this.parsers[block.type](block.data, this.config);
        }
        catch (err) {
            return err;
        }
    }
}
export const EditorParser = new edjsParser();
//# sourceMappingURL=EditorParser.js.map